import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './store/store';
import App from './App';
import { unstable_HistoryRouter as Router } from 'react-router-dom';
import './style/reset.css';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import history from '@/utils/history';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <ReduxProvider store={store}>
    <ConfigProvider locale={zhCN}>
      <Router history={history}>
        <App />
      </Router>
    </ConfigProvider>
  </ReduxProvider>
);
